export default __webpack_public_path__ + "static/media/Group8396.6c556419.svg";